module.exports = __webpack_public_path__ + "static/media/lights111.b47b77b3.jpg";